export const CharacterCatalog = {

    "babygirl": {
        name: "Baby Girl",
        modelUrl: "./characters/babygirl.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.22,
        speedRunning: 3.5,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_3", "Mirror_Viewing"],
            sit: null,
            slowWalk: ["Look_Around_Dumbfounded"],
            walk: "Walking",
            climb: "Fast_Ladder_Climb",
            run: "Running"
        },
        loop: true,
        ref: null
    },

    "furie": {
        name: "Furie",
        modelUrl: "./characters/furie.glb",
        indexPosition: [0, .11, 0],
        scale: 2.2,
        speed: 1.9,
        speedRunning: 4,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],

        animations: {
            idle: ["Backflip", "Idle_13"],
            sit: null,
            slowWalk: ["Thoughtful_Walk"],
            walk: "Walking",
            climb: "Fast_Ladder_Climb",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "landwolf": {
        name: "Landwolf",
        modelUrl: "./characters/landwolf.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 3,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],

        animations: {
            idle: ["Backflip","Idle_13","Idle_14"],
            sit: null,
            slowWalk: ["Look_Around_Dumbfounded"],
            walk: "Walking",
            climb: "Fast_Ladder_Climb",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "cyclops_anatomy": {
        name: "Cyclops Anatomy",
        modelUrl: "./characters/cyclops_anatomy.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_13","Idle_8"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "splitkid": {
        name: "Split Kid",
        modelUrl: "./characters/splitkid.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle","Short_Breathe_and_Look_Around"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "frankenstein": {
        name: "Frankenstein",
        modelUrl: "./characters/frankenstein.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_8","Idle_13","Frankenstein_Walk"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "ghosty": {
        name: "Gator",
        modelUrl: "./characters/gator2.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Axe_Breathe_and_Look_Around","Look_Around_Dumbfounded"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "cyclops_chick": {
        name: "Cyclops Chick",
        modelUrl: "./characters/cyclops_chick.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle","Idle_13","Axe_Breathe_and_Look_Around"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "sentinel": {
        name: "Sentinel",
        modelUrl: "./characters/sentinel.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_2","Idle_3","Idle_8"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "gator": {
        name: "Gator",
        modelUrl: "./characters/gator2.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_7"],
            sit: null,
            slowWalk: ["Casual_Walk"],
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "goblin": {
        name: "Goblin",
        modelUrl: "./characters/goblin.glb",
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Look_Around_Dumbfounded"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "cowboy": {
        name: "Cowboy",
        modelUrl: "./characters/cowboy.glb",
        scale: 2.2,
        speed: 2.75,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        // saturation: 0.33,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_6"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
    "pepe": {
        name: "Pepe",
        modelUrl: "./characters/pepe.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.25,
        speedRunning: 3.7,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["backflip", "mage_soell_cast_5","Idle_9"],
            sit: ["Dozing_Elderly"],
            slowWalk: ["Look_Around_Dumbfounded"],
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },
   

    "jabber": {
        name: "Jabberwocky",
        modelUrl: "./characters/jabber_limping.glb",
        position: [-30, 0, 11],
        scale: 2,
        speed: 0.5,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 1,
        idleTimeMax: 3,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: "Armature|Slow_Orc_Walk|baselayer",
            walk: "Armature|Slow_Orc_Walk|baselayer",
            run: "Armature|Slow_Orc_Walk|baselayer"
        },
        loop: true,
        ref: null
    },

    // "marvindog": {
    //     name: "Marvin Dog",
    //     modelUrl: "./characters/marvindog.glb",
    //     indexPosition: [0, -0.04, 0],
    //     scale: 7,
    //     speed: 1.4,
    //     isDog: true,
    //     speedRunning: 5,
    //     waypointRadius: 0.5,
    //     idleTimeMin: 1,
    //     idleTimeMax: 3,
    //     waypoints: [
    //         [-30, 0, -13],
    //         [-20, 0, -13],
    //         [-10, 0, -13],
    //         [0, 0, -13],
    //         [10, 0, -13],
    //         [20, 0, -13],
    //         [30, 0, -13],
    //         [40, 0, -13]
    //     ],
    //     animations: {
    //         idle: null,
    //         walk: "Walking",
    //         run: null,
    //     },
    //     isDog: true,
    //     loop: true,
    //     ref: null
    // },
    // "shibainu": {
    //     name: "Shibainu",
    //     modelUrl: "./characters/shibainu.glb",
    //     indexPosition: [0, -0.04, 0],
    //     scale: 7,
    //     speed: 1.4,
    //     isDog: true,
    //     speedRunning: 5,
    //     waypointRadius: 0.5,
    //     idleTimeMin: 1,
    //     idleTimeMax: 3,
    //     waypoints: [
    //         [-30, 0, -13],
    //         [-20, 0, -13],
    //         [-10, 0, -13],
    //         [0, 0, -13],
    //         [10, 0, -13],
    //         [20, 0, -13],
    //         [30, 0, -13],
    //         [40, 0, -13]
    //     ],
    //     animations: {
    //         idle: null,
    //         walk: "Walking",
    //         run: null,
    //     },
    //     isDog: true,
    //     loop: true,
    //     ref: null
    // },
    "pumpkinhead": {    
        name: "Pumpkin Head",
        modelUrl: "./characters/pumpkinhead.glb",
        position: [14, 0, -11],
        indexPosition: [0, -0.04, 0],
        scale: 2.5,
        speed: 2,
        speedRunning: 5,
        waypointRadius: 0.5,
        idleTimeMin: 1,
        idleTimeMax: 3,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_9"],
            walk: "Walking",
            run: "Running",
        },
        loop: true,
        ref: null
    },
    "pirate": {
        name: "Pirate",
        modelUrl: "./characters/pirate.glb",
        position: [14, 0, -11],
        indexPosition: [0, -0.04, 0],
        scale: 3.7,
        speed: 0.5,
        speedRunning: 5,
        waypointRadius: 0.5,
        idleTimeMin: 1,
        idleTimeMax: 3,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: "Idle",
            walk: "Injured_Walk",
            run: "Running"
        },
        loop: true,
        ref: null
    },

    // "zoey": {
    //     name: "Zoey",
    //     modelUrl: "./characters/zoey.glb",
    //     position: [-64, 0.1, -18],
    //     rotation: [0, Math.PI/2, 0],
    //     scale: 1.7,
    //     speed: 0,
    //     speedRunning: null,
    //     waypointRadius: 0.5,
    //     idleTimeMin: 5,
    //     idleTimeMax: 9,
    //     waypoints: [],
    //     animations: {
    //         start: ["Armature|Idle_9|baselayer"],
    //         idle: ["Idle_9"],
    //         walk: "Walking",
    //         run: "Running"
    //     },
    //     loop: true,
    //     ref: null
    // },

   

    "mothman": {
        name: "Mothman",
        modelUrl: "./characters/mothman.glb",
        position: [44, 0, -12],
        scale: 2.5,
        speed: 1.25,
        speedRunning: 7,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [20, 0.1, -12],
            [-10, 0.1, -13],
            [0, 0.1, -13],
            [10, 0.1, -13]
        ],
        animations: {
            start: ["Axe_Breathe_and_Look_Around"],
            idle: ["Idle", "Axe_Breathe_and_Look_Around"],
            walk: "Slow_Orc_Walk",
            run: "Running"
        },
        loop: true,
      
    },

    "grippy": {
        name: "Grippy",
        modelUrl: "./characters/grippy.glb",
        position: [44, 0.1, -12],
        scale: 2.5,
        speed: 1.25,
        speedRunning: 7,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [20, 0.1, -12],
            [-10, 0.1, -13],
            [0, 0.1, -13],
            [10, 0.1, -13]
        ],
        animations: {
            start: ["Axe_Breathe_and_Look_Around"],
            idle: ["Idle_9", "Idle_7", "Axe_Breathe_and_Look_Around", "Look_Around_Dumbfounded"],
            walk: "Proud_Strut",
            run: "Running"
        },
        loop: true,
     
    },

    "noodleface": {
        name: "Noodleface",
        modelUrl: "./characters/noodleface.glb",
        position: [18, 0, -13],
        indexPosition: [0, .11, 0],
        scale: 2,
        speed: 2.2,
        speedRunning: null,
        waypointRadius: 0.5,
        idleTimeMin: 1,
        idleTimeMax: 3,
        waypoints: [
            [-20, 0, -13],
            [-10, 0, -13],
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: "Idle_9",
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },




     // "spider": {
    //     name: "Animated Spider",
    //     modelUrl: "./characters/animated_spider.glb",
    //     position: [-11, 62, 21],
    //     scale: 1,
    //     speed: 1.5,
    //     speedRunning: null,
    //     waypointRadius: 2,
    //     idleTimeMin: 2,
    //     idleTimeMax: 5,
    //     waypoints: [
    //         // Start high on building
    //         [-9, 62, 22],
    //         [-11, 84, 22],
    //         [-9, 62, 22],
    //         [-7, 62, 11.7],
    //         [-7, 62, 15.7],
    //         // Gradual descent to ground
    //         [-7, 50, 15.7],
    //         [-7, 30, 15.7],
    //         [-7, 15, 15.7],
    //         [-8, 0.1, 15.7],
    //         // Ground level patrol
    //         [20, 0.1, -13.7],
    //         [-20, 0.1, -11],
    //         [7, 0.1, 13],
    //         [2.6, 0.1, 15.7],
    //         [15, 0.1, 5],
    //         [-15, 0.1, 5],
    //         [10, 0.1, -10],
    //         [-10, 0.1, -10],
    //         [0, 0.1, 0],
    //         [-5, 0.1, 5],
    //         [5, 0.1, -5],
    //         [-8, 0.1, 15.7]
    //     ],
    //     animations: {
    //         idle: "Idle",
    //         walk: "Walk",
    //         run: "Run"
    //     },
    //     loop: true,
    //     ref: "spiderRef"
    // },

    "furiewitch": {
        name: "Furie Witch",
        modelUrl: "./characters/furiewitch.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.5,
        speedRunning: 4.0,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Long_Breathe_And_Look_Around"],
            sit: null,
            slowWalk: ["Walk_Slowly_And_Look_Around"],
            walk: "Walking_Woman",
            run: ["Running","Skip_Forward"]
        },
        loop: true,
        ref: null
    },

    "blockyboy": {
        name: "Blocky Boy",
        modelUrl: "./characters/blockyboy.glb",
        position: [-30, 0.11, 11],
        scale: 1.5,
        speed: 2,
        speedRunning: 3.5,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_1","Idle_11"],
            sit: null,
            slowWalk: ["Thoughtful_Walk"],
            walk: "Walking",
            climb: "Fast_Ladder_Climb",
            run: "Running"
        },
        loop: true,
        ref: null
    },

  
    "skull": {
        name: "Skull",
        modelUrl: "./characters/skull.glb",
        position: [-30, 0.11, 11],
        scale: 2.2,
        speed: 2.0,
        speedRunning: 4.0,
        waypointRadius: 0.5,
        idleTimeMin: 5,
        idleTimeMax: 9,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, -13],
            [0, 0, -13],
            [10, 0, -13],
            [20, 0, -13],
            [30, 0, -13],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Alert","Idle_6","Backflip"],
            sit: null,
            slowWalk: ["Walk_Slow"],
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    },

    "mechalizard": {
        name: "Mechalizard",
        modelUrl: "./characters/mechalizard.glb",
        position: [-30, 0.11, 0],
        indexPosition: [0, 0, 0],
        anchor: "bottom",
        scale: 7.7,
        speed: 7,
        speedRunning: 11,
        waypointRadius: 0.5,
        idleTimeMin: 4,
        idleTimeMax: 8,
        waypoints: [
            [-30, 0, -13],
            [-20, 0, -13],
            [-10, 0, 2],
            [0, 0, -13],
            [10, 0, -13],
            [30, 0, -13],
            [70, 0, 2],
            [40, 0, -13]
        ],
        animations: {
            idle: ["Idle_5","Alert","Idle_7"],
            sit: null,
            slowWalk: null,
            walk: "Walking",
            run: "Running"
        },
        loop: true,
        ref: null
    }


}